import { render, staticRenderFns } from "./DebitCard.vue?vue&type=template&id=06f64b64&"
import script from "./DebitCard.vue?vue&type=script&lang=js&"
export * from "./DebitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f64b64')) {
      api.createRecord('06f64b64', component.options)
    } else {
      api.reload('06f64b64', component.options)
    }
    module.hot.accept("./DebitCard.vue?vue&type=template&id=06f64b64&", function () {
      api.rerender('06f64b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/DebitCard.vue"
export default component.exports